import { UseTimeAction } from "./useTimer.actions";
import {
    TimerDirection,
    TimerStatus,
    UseTimerActionType,
    UseTimerState
} from "./useTimer.types";

const useTimerReducer = (
    state: UseTimerState,
    action: UseTimeAction
): UseTimerState => {
    switch (action.type) {
        case UseTimerActionType.Tick: {
            const { delta } = action.payload;

            return {
                ...state,
                time:
                    state.direction === TimerDirection.Up
                        ? state.time + delta
                        : state.time - delta
            };
        }
        case UseTimerActionType.Start: {
            const { initialTime } = action.payload;
            return {
                ...state,
                time: initialTime,
                status: TimerStatus.Running
            };
        }
        case UseTimerActionType.Stop: {
            return {
                ...state,
                status: TimerStatus.Stopped
            };
        }
        case UseTimerActionType.ChangeDirection: {
            const { direction } = action.payload;

            return {
                ...state,
                direction: direction
            };
        }
        default:
            return state;
    }
};

export { useTimerReducer };
